<template>
    <div class="body">
        <div class="container">
            <h1>Unavailable!</h1>
            <div class="ql-editor" v-html="event.preventExternalRegistrationsMessage"></div>
            
            <button @click="$router.back(); $router.back()">Go back </button>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props:{
        eventId: String
    },
    computed:{
      ...mapState([
        "event"
      ]),
      isBack(){
        if(this.$route.query.back){
            return true
        }
        return null
      }  
    },
    async mounted(){
        if(!this.event._id) await this.$store.dispatch('get', { path: 'events', key: 'event', id: this.eventId })
    }
}
</script>

<style scoped>
h1 {
    font-size: 3rem
}

.body {
    height: 100vh;
    background-color: white;
    display: flex;
    align-items: center;
}
.container {
    height: 70vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

button{
    padding: 10px;
    border: 1px solid black;
    background: white;
}

button:hover{
    background: rgb(245, 245, 245);
}
</style>